export const XHR_BASE_PATH = '/_napi/da-deviation/';
export const SHARED_API_BASE_PATH = `${XHR_BASE_PATH}shared_api`;

export enum ApiGetEndpoint {
  Deviation = '/deviation',
  Preload = '/preload',
  Who = '/who',
  Groups = '/groups',
  GroupFolders = '/group_folders',
  Backgrounds = '/backgrounds',
}

export enum ApiPostEndpoint {
  Hide = '/hide',
  Unhide = '/unhide',
  GroupAdd = '/group_add',
  SetBackground = '/set_background',
  SetViewMode = '/set_view_mode',
}

export const acceptableDeviationTypes = [
  'art',
  'journal',
  'commission',
  'status-update',
  'poll',
];
